import 'vue-range-slider/dist/vue-range-slider.css';

import Vue from 'vue';
// @ts-ignore
import RangeSlider from 'vue-range-slider';

Vue.component('VRangeSlider', RangeSlider);

export default RangeSlider;
